<template>
  <div class="login" :style="{backgroundImage: 'url(' + imagePath.loginBGI + ')',}">
    <!-- 登录页头部 -->
    <LoginHeader />
    <div class="container">
      <!-- 二维码登录 -->
      <LoginByQRCode
        v-if="loginShow === 1"
        :QrCodeUrl="QrCodeUrl"
        :isExpired="isExpired"
        @handleSwitchLogin="handleSwitchLogin"
        @getQR="getQR"
      />
      <!-- 账号登录或手机号登录 -->
      <LoginByPwdOrCode
        v-else-if="loginShow === 2"
        :loginForm="loginForm"
        :state="state"
        @login="submitForm"
        @getSMS="getSMS"
        @handleSwitchLogin="handleSwitchLogin"
        @changeForm="changeForm"
      />
      <!-- 找回密码 -->
      <RetrievePsd
        v-else-if="loginShow === 3"
        :loginForm="loginForm"
        :state="state"
        @changeForm="changeForm"
        @revisePsd="revisePsd"
        @getSMS="getSMS"
      />
    </div>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";
import LoginHeader from "./components/LoginHeader.vue";
import LoginByQRCode from "./components/LoginByQRCode.vue";
import LoginByPwdOrCode from "./components/LoginByPwdOrCode.vue";
import RetrievePsd from "./components/RetrievePsd.vue";
import { mapActions } from "vuex";
import { resetPsd, getSMS, getQR, getQrCodeStatus } from "@/api/login";

export default {
  name: "Login", // 登录页
  components: {
    LoginHeader,
    LoginByQRCode,
    LoginByPwdOrCode,
    RetrievePsd
  },
  data() {
    return {
      imagePath,
      QrCodeUrl: "", // 登录二维码唯一id
      loginShow: 2, // 1二维码登录 2密码或验证码登录 3找回密码
      loginForm: {
        phone: "", // 账号
        password: "", // 密码
        code: "", // 验证码
        type: 0 // 0账号密码登录 1手机号验证码登录
      },
      state: {
        btnState: false, // 按钮状态loading
        smsTime: 60, // 短信倒计时时间
        codeDisabled: false, // 短信是否禁用
        codeMsg: "获取验证码", // 短信按钮上的文字
        timer: null // 短信上的定时器
      },
      QrCodeTimer: null, // 二维码定时器 监测二维码是否被扫的
      isExpired: false // 二维码是否过期
    };
  },
  methods: {
    ...mapActions(["Login"]),
    // 裁剪出真正的二维码id
    interceptQRCodeUrl(QrCodeUrl) {
      const arr = QrCodeUrl.split("=");
      // console.log(arr[arr.length - 1], "二维码id");
      this.isExpired = false

      this.getQrCodeStatus(arr[arr.length - 1]);

      // 用户一分钟之内没有操作，二维码自动过期
      setTimeout(() => {
        this.isExpired = true
      }, 60000)
    },
    // 循环获取扫码登录状态 每隔2s
    async getQrCodeStatus(url) {
      clearTimeout(this.QrCodeTimer);

      // 切换到别的登录方式或者二维码已过期就停止轮询
      if (Number(this.loginShow) !== 1 || this.isExpired) return;

      const { data, status } = await getQrCodeStatus(url);
      if (status === 200) {
        if (data === null) {
          // 请求成功 一秒钟调用一次查看状态
          this.QrCodeTimer = setTimeout(() => {
            this.getQrCodeStatus(url);
          }, 2000);
        } else {
          localStorage.setItem("token", data);
          await this.$router.push("/home");
        }
      } else {
        this.$message.error(data);
      }
    },
    // 获取二维码唯一id
    async getQR() {
      const { data, status,msg } = await getQR();
      if (status === 200) {
        // console.log(data, "获取二维码唯一id");
        this.QrCodeUrl = data;
        this.interceptQRCodeUrl(data);
      }else {
        this.$message.error(msg)
      }
    },
    // 获取短信验证码
    async getSMS() {
      this.getCodeStr();
      const { data, status, msg } = await getSMS(this.loginForm);
      if (status === 200) {
        console.log(data, "获取验证码成功");
        // this.$message.success("获取验证码成功！");
      } else {
        this.$message.error(msg);
      }
    },
    // 获取短信按钮上的文字
    getCodeStr() {
      // console.log(1);
      this.state.codeDisabled = true;
      // 验证码60秒倒计时
      if (!this.state.timer) {
        this.state.timer = setInterval(() => {
          if (this.state.smsTime > 0 && this.state.smsTime <= 60) {
            this.state.smsTime--;
            if (this.state.smsTime !== 0) {
              this.state.codeMsg = "重新发送(" + this.state.smsTime + ")";
            } else {
              clearInterval(this.state.timer);
              this.state.codeMsg = "获取验证码";
              this.state.smsTime = 60;
              this.state.timer = null;
              this.state.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },
    // 找回密码
    async revisePsd() {
      const { data, status, msg } = await resetPsd(this.loginForm);
      if (status === 200) {
        console.log(data);
        this.$message.success("更换密码成功，请重新登录");
        this.handleSwitchLogin(2);
      } else {
        this.$message.error(msg);
      }
    },
    // 提交登录
    submitForm() {
      this.state.btnState = true;
      const { state, Login, loginForm } = this;
      Login(loginForm)
        .then((res) => this.loginSuccess(res))
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          state.btnState = false;
        });
    },
    // 登录成功
    loginSuccess(res) {
      this.$router.push("/home");
      console.log(res, "登录成功");
    },
    // 登录失败
    requestFailed(err) {
      err?.status === 423 && this.$message.error('暂未开通电子课件资源库，可登录逻辑狗·家园共育APP开通哦');
    },
    // 切换登录页面
    handleSwitchLogin(val) {
      this.loginShow = val;
      this.loginForm.password = "";
      this.loginForm.code = "";
    },
    // 修改表单信息
    changeForm(name, val) {
      this.loginForm[name] = val;
    }
  }
};
</script>

<style scoped lang="less">
.login {
  width: 100vw;
  // height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 107px);
  }
}
</style>
